enum ToolTipPosition {
	TOP = 'top',
	RIGHT = 'right',
	BOTTOM = 'bottom',
	LEFT = 'left',
	NONE = 'none',
}

export default ToolTipPosition;